export const SET_PRIMARY_TRADEBOOK = 'SET_PRIMARY_TRADEBOOK';
export const SET_SECONDARY_TRADEBOOK = 'SET_SECONDARY_TRADEBOOK';
export const SET_TRADEBOOKS = 'SET_TRADEBOOKS';
export const SET_DEAL_INFOS = 'SET_DEAL_INFOS';
export const SET_DEFAULT_TRADEBOOKS = 'SET_DEFAULT_TRADEBOOKS';
export const RESET_TRADEBOOKS = 'RESET_TRADEBOOKS';
export const SET_TRADEBOOKS_ADJUSTMENT = 'SET_TRADEBOOKS_ADJUSTMENT';
